import React, { useEffect, useRef, useState } from "react";
import { Box, Step, StepLabel, Stepper, Grid, Modal, Button } from "@mui/material";
import { STEPPERNAME } from "../../../../../utils/constants/htmlConstants"
import StepOne from "../flight-shop-form/StepOne";
import FlightShopSettings from "../flight-shop-settings";
import "../../addmarket.scss";
import StepTwo from "../flight-shop-form/StepTwo";
import StepThree from "../flight-shop-form/StepThree";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { resetFormOptions, setForm3Options } from "../../../../../services/slices/addformSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import APIServices from "../../../../../services/api-services";
import { defaultFlightShopsFilter, isValue, type } from "../../../../../utils/constants/constants";
import { alreadyReachedMax, removeChartDashboardShop, removeChartGroupOnlyShop, removeChartGroupShopContent } from "../../../../../utils/helpers/helper";
import { setLogoutSession } from "../../../../../services/slices/authTokenSlice";
import { clearAllReduxStates } from "../../../../../utils/common-hooks/clearState";
import { persistor } from "../../../../../store/store";
import CustomModal from "../../../../../components/common/modal/customModal";
import Spinner from "../../../../../layout/spinner/spinner";
import { reSetMyMarketFilterFormData } from "../../../../../services/slices/filterFormDatas";
import { responseData } from "../../../../../utils/helpers/helper";

const AddFlightShopForm = (props) => {
  const dispatch = useDispatch()
  const { shopid } = useParams();
  const location = useLocation();

  const navigate = useNavigate();
  const controller = useRef(null);
  const fetchMarketGroupController = useRef();
  const fetchMyMarketController = useRef(null);
  const getSourcesAll = useRef(null);

  const { state } = location;
  const { activeStep, setActiveStep } = props;
  const { fetchMyMarket, fetchVisualizedCount, getSources, fetchMarketGroup, bulkConFirmInGroup } = APIServices();

  const { userdetails } = useSelector((state) => state.userDetails);
  const { form1Options, form2Options, form3Options } = useSelector(state => state?.addShop);

  const shop = useSelector((state) => state.addShop);
  const { mymarket } = useSelector((state) => state.MyMarket);
  const { searchFlightShopResult: { source } } = useSelector((state) => state.addFlightShop);
  const { myMarketFilterFormData } = useSelector(state => state.filterForm);
  const { sourceDatas } = useSelector(state => (state.source));
  // A count this form loaded itself is newer than the stored one (see refreshVisualizedCount)
  const [loadedVisCount, setLoadedVisCount] = useState(undefined);
  const visCount = loadedVisCount ?? mymarket?.visCount
  const addFlightShop = shop?.addFlightShop;

  const { isVisualize } = userdetails;
  const vizLimit = userdetails?.vizLimit || 50;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({})
  const [checkIds, setCheckIds] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(isValue?.emptyString);
  const [modalTypes, setModalTypes] = useState(isValue?.emptyString);
  const [openModal, setOpenModal] = useState(false);
  const [tempSubmitData, setTempSubmitData] = useState(null);
  const [tempSubmitCondition, setTempSubmitCondition] = useState({});
  const [updateSource, setUpdateSource] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const [formCompleted, setFormCompleted] = useState(false);
  const [formError, setFormError] = useState(false);
  const [alertError, setAlertError] = useState(isValue?.emptyString);
  useEffect(() => {
    setUpdateSource(sourceDatas);
  }, [sourceDatas])

  // Loads the account's current visualized-shop count (used by the limit warning below). Only the
  // count is stored: the My Market list and its filter are left exactly as the user had them.
  const visCountController = useRef(null);
  const refreshVisualizedCount = () => fetchVisualizedCount(visCountController).then((count) => {
    if (typeof count === "number") setLoadedVisCount(count)
  }).catch(() => { })

  // No count yet (e.g. a fresh login that did not open My Market): load it, so the warning can work
  useEffect(() => {
    if (isVisualize && mymarket?.visCount === undefined) refreshVisualizedCount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // The API refused the save because of the visualized-shop limit (the count here was out of date):
  // show its message in the same warning, switch charts back to No and load the current count
  const showLimitRefusal = (error) => {
    const refusal = responseData(error?.response)
    if (error?.response?.status !== 400 || refusal?.code !== "visualize_shop_limit") return false
    setLoading(false)
    setModalContent([{ modalHeading: "Warning" }, { modalContent: refusal.message }]);
    setModalOpen(true);
    setModalTypes("restrictadd");
    dispatch(setForm3Options({ ...form3Options, charts: "No" }));
    refreshVisualizedCount()
    return true
  }

  const handleSubmit = async () => {
    const err = {};

    // Check for frequency and related data
    if (form3Options?.frequency === "Weekly" && !form3Options?.weekDays?.length) {
      err.weekDays = "Weekly days is required";
    } else if (form3Options?.frequency === "Monthly" && !form3Options?.monthDaysAdd?.length) {
      err.monthDays = "Monthly date is required";
    } else if (form3Options?.frequency === "Custom" && !form3Options?.customAdd?.length) {
      err.monthDays = "Flightshop frequency is required";
    }
    // Check if delivery zone is selected
    if (!form3Options?.deliveryzone?.length) {
      err.time = "Please add delivery time and timezone";
    }

    // Check if start date is provided
    if (!form3Options?.startDate) {
      err.startDate = "Start Date is required";
    }

    // Check if end date is required and provided
    if (form3Options?.needEndDate === "Yes" && !form3Options?.endDate) {
      err.endDate = "End date is required";
    } else if (form3Options?.needEndDate === "Yes" && form3Options?.endDate < form3Options?.startDate) {
      err.endDate = "End date should be greater than Start date";

    }

    // Check if shop name is empty
    if (form3Options?.shopName === "") {
      err.shopName = "Shop Name is required";
    }
    const shopNameExists = sourceDatas?.shopName?.length ? sourceDatas?.shopName?.filter(data => data.shopName === form3Options?.shopName) : []
    if (shopNameExists?.length && !state?.editFlightshop) {
      err.shopName = "Shop name Already exsist";
    } else if (form3Options?.existShopName !== form3Options?.shopName && shopNameExists?.length && state?.editFlightshop) {
      err.shopName = "Shop name Already exsist";
    }
    // If there are errors, you can display them or handle them as needed
    if (Object.keys(err).length > 0) {
      // You can show the errors to the user or handle them as needed
      setError(err)
    } else {
      console.log("Form is valid, submitting...");
      let enableCharts = form3Options?.charts === "Yes" || form3Options?.charts.includes("Yes") || false;
      const finalData = { ...form3Options, isVisualizeShop: isVisualize ? form3Options?.charts === "Yes" : false }
      const checkInGroups = shopid !== "new" ? await bulkConFirmInGroup(parseInt(shopid), controller, setLoading, () => { }) : [];
      const includeShopsIds = checkInGroups?.shopDetails?.length !== 0 ? checkInGroups?.shopDetails?.filter((res) => res?.exists === true) : "";
      setCheckIds(includeShopsIds)
      const existChart = form3Options?.chartsExist === "Yes" || form3Options?.chartsExist.includes("Yes") || false;
      if ((!state?.editFlightshop && visCount >= vizLimit && enableCharts) || (state?.editFlightshop && visCount >= vizLimit && enableCharts && !existChart)) {
        setLoading(false)
        setModalContent(alreadyReachedMax(vizLimit));
        setModalOpen(true);
        setModalTypes("restrictadd");
        enableCharts = false
        dispatch(setForm3Options({ ...form3Options, charts: "No" }));
        return
      } else if (!form1Options?.ota?.length && !form1Options?.brands?.length && !form1Options?.meta?.length && !form1Options?.gds?.length) {
        setOpenModal(true);
        setTempSubmitData(finalData);
        setTempSubmitCondition(checkInGroups?.chartDetails || {})
      } else if (includeShopsIds?.length > 0 && enableCharts === false && isVisualize && state?.editFlightshop) {
        setTempSubmitData(finalData);
        setTempSubmitCondition(checkInGroups?.chartDetails || {})
        const deletegroup = includeShopsIds?.flatMap((res) => res?.deletingGroup);
        const deleteDashboard = includeShopsIds?.flatMap((res) => res?.deletingDashboard);
        if (deleteDashboard?.length) {
          setModalContent(removeChartDashboardShop);
        } else if (deletegroup?.length) {
          setModalContent(removeChartGroupOnlyShop);
        } else {
          setModalContent(removeChartGroupShopContent);
        } setModalOpen(true);
        setModalTypes("onSubmid");
      } else {
        setTempSubmitCondition(checkInGroups?.chartDetails || {})
        dispatch(setForm3Options(finalData));
        setLoading(true)
        handleAddMarket(finalData, checkInGroups?.chartDetails);
      }
    }
  };

  const handleAddMarket = async (data, chartDetails) => {
    const flyfromSpilted = addFlightShop?.flyFrom !== "" ? addFlightShop?.flyFrom?.split("-") : "";
    const flytoSplitted = addFlightShop?.flyTo !== "" ? addFlightShop?.flyTo?.split("-") : "";
    const flyFromIata = flyfromSpilted[flyfromSpilted?.length - 1]?.trim();
    const flyToIata = flytoSplitted[flytoSplitted?.length - 1]?.trim();
    const sortNumArray = (arr) => {
      if (!Array.isArray(arr)) return [];
      const mapped = arr.filter((x) => x !== null && x !== undefined && x !== "").map(Number).filter((n) => !Number.isNaN(n));
      return [...new Set(mapped)].sort((a, b) => a - b);
    };

    // Proceed with form submission
    const payload = {
      "fsId": shopid && !(state?.cloneflightkey) ? parseInt(shopid) : null,
      "editShop": shopid !== "new" && typeof parseInt(shopid) === "number" && !state?.cloneflightkey ? true : false,
      "shopName": form3Options?.shopName,
      "flyFrom": flyFromIata,
      "flyTo": flyToIata,
      "carriers": sortNumArray([...(form1Options?.yourAirline || []), ...(form1Options?.brands || [])]),
      "historicalData": form2Options?.history?.includes("yes"),
      "rateparityData": form1Options?.rateparity?.includes("Yes"),
      "cabinClass": sortNumArray([form2Options?.cabinClass === "Economy" ? 1 : form2Options?.cabinClass === "Business" ? 2 : form2Options?.cabinClass === "First Class" ? 3 : 4]),
      "sources": sortNumArray([...(form1Options?.gds || []), ...(form1Options?.meta || []), ...(form1Options?.ota || [])]),
      "routeType": { "rtType": form2Options?.route === "OW" ? 1 : 2, "los": form2Options?.los ? sortNumArray(Array.isArray(form2Options.los) ? form2Options.los : form2Options.los.toString().split(',')) : [] },
      "los": null,
      "customHorizon": form2Options?.customDay !== undefined && form2Options?.customDay !== null && form2Options?.customDay !== "" ? [form2Options?.customDay] : [],
      "horizonStartDate": form2Options?.startDate,
      "horizonEndDate": form2Options?.endDate,
      "pax": { "adults": parseInt(form2Options?.adults), "infants": form2Options?.infants && form2Options?.infants !== null ? parseInt(form2Options?.infants) : 0 },
      "frequency": {
        "refresh": form3Options?.frequency, "days": form3Options?.frequency === "Weekly" && form3Options?.weekDays ? form3Options?.weekDays : form3Options?.monthDaysAdd ? form3Options?.monthDaysAdd : [], "time": form3Options?.deliveryzone,
        "startDate": form3Options?.startDate,
        "endDate": form3Options?.needEndDate === "Yes" ? form3Options?.endDate : null || null
      },
      "pos": form2Options?.pos,
      "currency": form2Options?.currency,
      "maxStops": form2Options?.maxStops === "All" ? -1 : parseInt(form2Options?.maxStops),
      "maxDuration": form2Options?.maxDuration === "All" ? -1 : parseInt(form2Options?.maxDuration),
      "historicalHorizon": form2Options?.historicalHorizon,
      "horizonDays": form2Options?.horizonDays,
      "isVisualizeShop": isVisualize && form3Options?.charts.includes("Yes"),
      "isGds": form1Options?.gds.includes(430),
      "isTravelportGds": form1Options?.gds.includes(445),
      "customFrequency": form3Options?.frequency === "Custom" ? form3Options?.customAdd.map((data) => {
        const dateWeeks = typeof (data) === "number" ? [data] : !data.includes("/") ? [parseInt(data)] : [parseInt(data?.split("/")?.[1])]
        const dayWeeks = typeof (data) === "number" ? [] : !data.includes("/") ? [] : data?.split("/")?.[0].split(",").map(q => parseInt(q))
        return { days: dayWeeks, dateWeek: dateWeeks }
      }) : [],
      "isAncillary": form1Options?.isAncillary?.includes("Yes"),
      // "isDeepsearch": form1Options?.isDeepsearch?.includes("Yes")
    }


    const otalist = source?.filter((res) => res?.sourceType === 'OTA')?.map((res) => res?.code);

    const OTAMeta = payload?.sources?.some((res) => otalist?.includes(res))

    const { rateparityData, historicalData, isVisualizeShop: isViz } = payload || {};

    setCheckIds("");

    const libraryCheck = Object.keys(tempSubmitCondition)?.length > 0 ? Object.values(tempSubmitCondition || {})?.some(value => value === true) : Object.values(chartDetails || {}).some(value => value === true)
    if ((updateSource?.allShopDashboard?.isAdded && !!isViz) || (libraryCheck && !!isViz)) {
      const { needRateparity, needHistorical, needOtaMeta } = updateSource.allShopDashboard || {};
      const { needMetasource, needHistoricalData, needOtasMetasource } = Object.keys(tempSubmitCondition)?.length > 0 ? tempSubmitCondition || {} : chartDetails || {};
      const alerts = {
        noCharts: {
          title: "Enable Charts",
          content: `To complete your shop creation and view your charts, please ensure that the "Enable Charts" option is selected in Step 3. This setting is required to populate your dashboard with the relevant data.`,
          tabStatus: 2
        },
        allRequired: {
          title: "Select Rateparity, OTA or Metasource and Historical Data",
          content: "Your dashboard includes analyses that require data from Google Flights and  historical data. Please go back to Step 1 and add rateparity then go to Step 2 and select a historical horizon of up to 60 days as a data source to proceed.",
          tabStatus: 0
        },

        rateparityHistorical: {
          title: "Select Rateparity and Historical Data",
          content: "Your dashboard includes analyses that require data from Google Flights and  historical data. Please go back to Step 1 and add rateparity then go to Step 2 and select a historical horizon of up to 60 days as a data source to proceed.",
          tabStatus: 0
        },
        rateparityOta: {
          title: "Select Rateparity and OTA or Metasource",
          content: "Your dashboard includes analyses that require data from Google Flights. Please go back to Step 1 and add rateparity or select at least one OTA or metasource (e.g., Google) as a data source to proceed.",
          tabStatus: 0
        },
        historicalOta: {
          title: "Select OTA or Metasource and Historical Data",
          content: "To ensure your charts are populated with the necessary data, please select at least one OTA or metasource (e.g., Google) in Step 1 and go to Step 2 and select a historical horizon of up to 60 days. These sources are essential for certain analyses on your dashboard.",
          tabStatus: 1
        },
        rateparity: {
          title: "Select Rateparity Data",
          content: "Your dashboard includes analyses that require data from Google Flights. Please go back to Step 1 and add rateparity data as a data source to proceed.",
          tabStatus: 0
        },
        historical: {
          title: "Select Historical Data",
          content: "Some analyses in your dashboard require historical data. Please go back to Step 2 and select a historical horizon of up to 60 days back to ensure your charts are fully populated.",
          tabStatus: 1
        },
        ota: {
          title: "Select OTA or Metasource",
          content: "To ensure your charts are populated with the necessary data, please select at least one OTA or metasource (e.g., Google) or add rateparity in Step 1. These sources are essential for certain analyses on your dashboard.",
          tabStatus: 0
        },
      };

      const showAlert = (message) => {
        setOpenAlert(true);
        setAlertContent(message);
      };
      if ((needRateparity || needMetasource) && (needHistorical || needHistoricalData) && (needOtaMeta || needOtasMetasource)) {
        setLoading(false);
        if (!rateparityData && !historicalData && !OTAMeta) {
          showAlert(alerts.allRequired);
        } else if (!rateparityData && !historicalData) {
          showAlert(alerts.rateparityHistorical);
        } else if (!rateparityData && !OTAMeta) {
          showAlert(alerts.rateparityOta);
        } else if (!historicalData && (!OTAMeta && !rateparityData)) {
          showAlert(alerts.historicalOta);
        } else if (!rateparityData) {
          showAlert(alerts.rateparity);
        } else if (!historicalData) {
          showAlert(alerts.historical);
        } else if (!OTAMeta && !rateparityData) {
          showAlert(alerts.ota);
        } else {
          makeApiCall(data, payload);
        }
      } else if ((needRateparity || needMetasource) && !rateparityData) {
        setLoading(false);
        showAlert(alerts.rateparity);
      } else if ((needHistorical || needHistoricalData) && !historicalData) {
        setLoading(false);
        showAlert(alerts.historical);
      } else if ((needOtaMeta || needOtasMetasource) && !OTAMeta && !rateparityData) {
        setLoading(false);
        showAlert(alerts.ota);
      } else {
        setLoading(false);
        makeApiCall(data, payload);
      }
    } else {
      setLoading(false);
      makeApiCall(data, payload);
    }
  }

  const makeApiCall = async (data, payload) => {

    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    if (
      shopid !== "new" &&
      typeof parseInt(shopid) === type?.number &&
      !isNaN(parseInt(shopid)) &&
      !state?.cloneflightkey
    ) {
      try {
        setLoading(true)
        const editPayload = { ...payload }
        const addMarket = await axios.put(
          `${process.env.REACT_APP_API_URL}${`market/${shopid}`}`,
          editPayload,
          config
        );
        if (addMarket?.status === 200) {
          setLoading(false);
          setFormCompleted(true);
          const marketGroupPayload = {
            groupName: isValue?.emptyString,
            market: isValue?.emptyString,
          };
          await fetchMarketGroup(
            marketGroupPayload, fetchMarketGroupController, () => { }, () => { }
          );
        }
      } catch (error) {
        if (showLimitRefusal(error)) return
        setLoading(false)
        console.log(error);
        setFormCompleted(true);
        setFormError(true)
        if (error?.response?.status === 401 && responseData(error?.response)?.message === "New login found.") {
          dispatch(setLogoutSession(true));
        } else if (error?.response?.status === 401) {
          clearAllReduxStates(dispatch)
          persistor.purge();
          sessionStorage.clear();
          localStorage.clear();
          navigate("/")
        }
      }
    } else {
      try {
        setLoading(true)
        const clonePayload = { ...payload, }
        const finalPayload = state?.cloneflightkey ? clonePayload : payload
        const addMarket = await axios.post(
          `${process.env.REACT_APP_API_URL}${'addmarket'}`,
          finalPayload,
          config
        );
        if (addMarket?.status === 200) {
          setLoading(false)
          setFormCompleted(true)
        }
      } catch (error) {
        if (showLimitRefusal(error)) return
        setLoading(false)
        console.log(error);
        setFormCompleted(true)
        setFormError(true)
        if (error?.response?.status === 401 && responseData(error?.response)?.message === "New login found.") {
          dispatch(setLogoutSession(true));
        } else if (error?.response?.status === 401) {
          clearAllReduxStates(dispatch)
          persistor.purge();
          sessionStorage.clear();
          localStorage.clear();
          navigate("/")
        }
      }
    }
  }

  const resetAndNavigate = async () => {
    dispatch(resetFormOptions());
    navigate("/shop_manager", { state: { from: "mymymarket" } });
    const myMarketPayload = {
      shopName: isValue?.emptyString,
      flyFrom: isValue?.emptyString,
      flyTo: isValue?.emptyString,
      frequency: [],
      days: [],
      status: 1,
      cabinClass: 0,
      page: 1,
      pageSize: 100,
      routeType: 0,
      pos: isValue?.emptyString,
      currency: isValue?.emptyString,
      sources: isValue?.emptyString,
      visualizeOnly: false,
      groupShops: [],
    }
    let data = myMarketFilterFormData;

    const filterPayload = {
      shopName: data?.shopName || isValue?.emptyString,
      flyFrom: (data?.flyFrom && data?.flyFrom?.split(" ")?.[0]?.trim()) || isValue?.emptyString,
      flyTo: (data?.flyTo && data?.flyTo?.split(" ")?.[0]?.trim()) || isValue?.emptyString,
      frequency: data?.frequency ? [data?.frequency] : [],
      days: data?.days && parseInt(data?.frequency) === 2 ? data?.days : [],
      status:
        data?.status === "Active"
          ? 1
          : data?.status === "Deleted"
            ? 4
            : data?.status === "Paused" ? 2 : 1,
      cabinClass:
        data?.cabinClass === "Economy"
          ? 1
          : data?.cabinClass === "Business"
            ? 2
            : data?.cabinClass === "First Class"
              ? 3
              : (data?.cabinClass === "Premium Economy" && 4) || 0,
      page: 1,
      pageSize: 100,
      routeType: data?.routeType || 0,
      pos: data?.pos || isValue?.emptyString,
      currency: data?.currency || isValue?.emptyString,
      maxStops: data?.maxStops || isValue?.emptyString,
      maxDuration: data?.maxDuration || isValue?.emptyString,
      sources: data?.source || "",
      visualizeOnly: data?.outputtype === "Data and Charts" ? true : false,
      nonvisualizeOnly: data?.outputtype === "Data only" ? true : false,
      groupShops: data?.groupshop ? [...data?.groupshop] : [],
    };
    let finalPayload = {}

    if (
      shopid !== "new" &&
      typeof parseInt(shopid) === type?.number &&
      !isNaN(parseInt(shopid)) &&
      !state?.cloneflightkey
    ) {
      finalPayload = myMarketPayload;
    } else {
      finalPayload = myMarketPayload;
    }
    dispatch(reSetMyMarketFilterFormData());

    const setError = () => { }
    await fetchMyMarket(
      finalPayload,
      fetchMyMarketController,
      setLoading,
      setError,
      loading,
    )
    await getSources(
      getSourcesAll,
      setLoading,
      setError,
      loading,
    )
  }

  const withoutOTA = async (e) => {
    e.preventDefault()
    setOpenModal(!openModal)
    if (checkIds?.length > 0 && !(form3Options?.charts === "Yes" || form3Options?.charts?.includes("Yes")) && isVisualize && state?.editFlightshop) {
      setModalContent(removeChartDashboardShop);
      setModalOpen(true);
      setModalTypes("onSubmid");
    } else {
      setLoading(true)
      handleAddMarket(tempSubmitData)
    }
  }

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setAlertContent("");
  }

  const handleTabChangeAlert = (tabStatus) => {
    setActiveStep(tabStatus);
    setOpenAlert(false);
    setAlertContent("");
    props.setIsFromPreviousPage(true)
    props.setActiveStep((prevStep) => tabStatus);
    dispatch(setForm3Options({ ...form3Options, charts: "Yes" }));
    if (props.activeStep === 2) {
      const finalData = { ...form3Options, isVisualizeShop: true }
      dispatch(setForm3Options(finalData));
    }
  }

  const withoutVisualise = () => {
    const finalData = { ...tempSubmitData, isVisualizeShop: false }
    setModalOpen(!modalOpen)
    dispatch(setForm3Options(finalData));
    setLoading(true)
    handleAddMarket(finalData);
  }

  return (
    <Box>
      <div className="shop-stepper">
        <Stepper activeStep={activeStep} alternativeLabel>
          {STEPPERNAME.map((label, index) => (
            <Step key={label}>
              <StepLabel completed={false.toString()}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      <Grid container columns={{ xs: 4, sm: 6, md: 12 }}>
        <Grid item xs={activeStep !== 1 ? 8 : 12}>
          {activeStep === 0 && <StepOne setActiveStep={setActiveStep} initialData={form1Options} />}
          {activeStep === 1 && <StepTwo setActiveStep={setActiveStep} initialData={form2Options} />}
          {activeStep === 2 && <StepThree setActiveStep={setActiveStep} initialData={form3Options} error={error} setError={setError} />}
        </Grid>
        {activeStep !== 1 && <Grid item xs={4}>
          <FlightShopSettings activeStep={activeStep} handleSubmit={handleSubmit} />
        </Grid>}
      </Grid>

      <Modal backdrop={"static"}
        open={!!formCompleted}
        className="common-modal">
        {alertError === isValue?.emptyString ?
          <Box className="modal-box">
            <h2>Flight Shop</h2>
            <p>{!formError ? `${shopid !== "new" &&
              typeof parseInt(shopid) === type?.number &&
              !state?.cloneflightkey
              ? "Shop updated successfully"
              : shopid !== "new" &&
                typeof parseInt(shopid) === type?.number &&
                state?.cloneflightkey
                ? "The flight shop has been successfully created and will be delivered as per your schedule."
                : "The flight shop has been successfully created and will be delivered as per your schedule."}` :
              `Your Shop is not ${shopid !== "new" &&
                typeof parseInt(shopid) === type?.number &&
                !state?.cloneflightkey
                ? "updated." : shopid !== "new" &&
                  typeof parseInt(shopid) === type?.number &&
                  state?.cloneflightkey
                  ? "duplicated" : "Created"} now try again later`}</p>
            <div className="textleft">
              <Button className="secondary_button2" onClick={() => {
                setFormCompleted(false);
                setFormError(false)
                if (!formError) {
                  resetAndNavigate()
                }
              }}>Ok</Button>
            </div>
          </Box>
          :
          <Box className="modal-box">
            <h2>Warning</h2>
            <p>{alertError}</p>
            <div className="textleft">
              <Button className="secondary_button2" onClick={() => {
                setFormCompleted(false);
                setAlertError(isValue?.emptyString)
              }}>Ok</Button>
            </div>
          </Box>
        }
      </Modal>
      {loading && <Spinner />}
      <CustomModal
        open={openModal}
        handleClose={() => setOpenModal(!openModal)}
        lable={{ labelOne: "close", labelTwo: "ok" }}
        cancellable={true}
        content={[{ header: "Warning" }, { modalContent: "Are you sure you want to continue without selecting any Brands, GDS, OTAs or MetaSources?" }]}
        handleClickOk={withoutOTA}
      />

      <CustomModal
        open={openAlert}
        handleClose={() => handleCloseAlert()}
        lable={{ labelOne: "close", labelTwo: "ok" }}
        cancellable={true}
        content={[{ header: alertContent?.title }, { modalContent: alertContent?.content }]}
        handleClickOk={() => handleTabChangeAlert(alertContent?.tabStatus)}
      />

      <CustomModal
        open={modalOpen}
        handleClose={() => { setModalOpen(!modalOpen) }}
        cancellable={true}
        type={modalTypes}
        content={modalContent}
        handleClickOk={() => modalTypes === "restrictadd" ? setModalOpen(!modalOpen) : withoutVisualise()}
      />
    </Box>
  );
};

export default AddFlightShopForm;
